<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="16rem"
      style="width: 65%"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">预警配置详情</div>
        </zj-layout-header>
      </zj-layout-container>
          <el-form-item
            label="预警源"
            prop="warnBusiness"
          >
            <el-col :span="7">
              <el-select v-model="form.warnBusiness" :disabled="!IsEdit" placeholder="请选择" @change="warnBusinessChange">
                <el-option
                  v-for="item in dict.type.warn_config_business"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" style="margin-left: 20px;">
              <treeselect
                v-model="form.warnPoint"
                :options="warnPointList"
                :disabled="!IsEdit"
                placeholder="请选择"
              />
            </el-col>
          </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item label="预警源类型" prop="warnType">
            <el-radio-group v-model="form.warnType" :disabled="!IsEdit">
                <el-radio
                  v-for="dict in dict.type.warn_config_type"
                  :key="dict.value"
                  :label="dict.value"
                >{{dict.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="是否弹框提醒" prop="popupFlag">
            <el-radio-group v-model="form.popupFlag" :disabled="!IsEdit">
                <el-radio
                  v-for="dict in dict.type.yes_no"
                  :key="dict.value"
                  :label="dict.value"
                >{{dict.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="预警配置" v-if="form.id && form.warnType == '1'">
            <WarnRule :warnConfigId="form.id" :IsEdit="IsEdit"></WarnRule>
          </el-form-item> 
        </el-col>
      </el-row>
      
      <el-form-item class="left">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addWarnConfig, getWarnConfigById, updateWarnConfig } from '@/api/src/warnConfig'
import { listEquipmentAreaTree, listEquipmentAreaTreePassengerFlow } from "@/api/src/equipmentArea";
import WarnRule from '../components/warnRule';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "WarnConfigInfo",
  controller: "UI",
  action: "WarnConfigInfo",
  dicts: [
    'warn_config_business',
    'warn_config_type',
    'yes_no'
  ],
  components:{
    WarnRule,
    Treeselect
  },
  data() {
    return {
      form: {
        warnBusiness: null,
        warnPoint: null,
        warnType: "1",
        popupFlag: null,
      },
      rules: {
        warnBusiness: [
          { required: true, message: "请选择预警业务", trigger: "change" },
        ],
        warnType: [
          { required: true, message: "请选择预警类型", trigger: "change" },
        ],
        popupFlag: [
          { required: true, message: "请选择是否弹框", trigger: "change" },
        ]
      },
      // 是否可编辑
      IsEdit: false,
      // 预警点列表
      warnPointList: [],
    };
  },
  created: function() {
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  methods: {
    // 查询区域树-除了客流密度
    getAreaTree(){
      return new Promise((resolve, reject) => {
        listEquipmentAreaTree().then(response =>{
          this.warnPointList = response.data;
          resolve(this.warnPointList)
        });
      })
    },
    // 查询区域树-客流密度
    getAreaTreePassengerFlow(){
      return new Promise((resolve, reject) => {
        listEquipmentAreaTreePassengerFlow({
          groupId: this.form.warnPoint
        }).then(response =>{
          response.data.densityAllGroupInfoDtoList.forEach(item => {
            item.id = item.groupId;
            item.label = item.groupName;
          });
          this.warnPointList = response.data.densityAllGroupInfoDtoList;
          resolve(this.warnPointList)
        });
      })
    },
    warnBusinessChange(val) {
      this.form.warnPoint = null;
      if (val == '4') {
        this.getAreaTreePassengerFlow();
      } else {
        this.getAreaTree();
      }
    },
    // 查询数据
    search() {
      getWarnConfigById(this.$route.query.id).then(response => {
        if (response.data.warnBusiness == '4') {
          this.getAreaTreePassengerFlow().then(res => {
            this.form = response.data;
          })
        } else {
          this.getAreaTree().then(res => {
            this.form = response.data;
          })
        }
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存按钮
    saveForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            updateWarnConfig(this.form).then(response => {
              this.$message({type: "success", message: "修改成功"});
              this.logInfo.ActionName = "预警配置修改";
              this.logInfo.LogMessage = "预警配置修改成功";
              this.logInfo.ModuleName = "预警系统";
              this.logInfo.PageName = "预警配置详情页";
              this.addOperationLog();
              this.$router.go(-1);
            });
          } else {
            addWarnConfig(this.form).then(response => {
              this.$message({type: "success", message: "新增成功"});
              this.logInfo.ActionName = "预警配置添加";
              this.logInfo.LogMessage = "预警配置添加成功";
              this.logInfo.ModuleName = "预警系统";
              this.logInfo.PageName = "预警配置详情页";
              this.addOperationLog();
              this.$router.go(-1);
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__single-value{
  line-height: 4rem;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
  width: 217px;
}
</style>